var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquarePlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.17 15h-2.3a.2.2 0 0 1-.2-.2v-2.3a.83.83 0 0 0-1.67 0v2.3a.2.2 0 0 1-.2.2h-2.3a.83.83 0 0 0 0 1.67h2.3a.2.2 0 0 1 .2.2v2.3a.83.83 0 0 0 1.67 0v-2.3a.2.2 0 0 1 .2-.2h2.3a.83.83 0 0 0 0-1.67ZM9.17 15H2.08a.42.42 0 0 1-.41-.42V2.08a.42.42 0 0 1 .41-.41h12.5a.42.42 0 0 1 .42.41v7.09a.83.83 0 0 0 1.67 0v-7.5A1.67 1.67 0 0 0 15 0H1.67A1.67 1.67 0 0 0 0 1.67V15a1.67 1.67 0 0 0 1.67 1.67h7.5a.83.83 0 0 0 0-1.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquarePlus);
export default __webpack_public_path__ + "static/media/square-plus.349454c9.svg";
export { ForwardRef as ReactComponent };